import React, { useState, useEffect, useRef } from 'react';
import { Building2, Ticket } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

const BookingPage = () => {
  const { language } = useLanguage();
  const [activeTab, setActiveTab] = useState('accommodation');
  const civitatisRef = useRef(null);

  const labels = {
    es: { accommodation: 'Alojamientos', activities: 'Actividades y Tickets' },
    en: { accommodation: 'Accommodation', activities: 'Activities & Tickets' },
    de: { accommodation: 'Unterkünfte', activities: 'Aktivitäten & Tickets' }
  };
  const t = labels[language] || labels.es;

  // Load Civitatis script when activities tab is active
  useEffect(() => {
    if (activeTab === 'activities' && civitatisRef.current) {
      const container = civitatisRef.current;
      // Only inject once
      if (container.querySelector('iframe')) return;

      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.textContent = `
        (function(){
          function loadScript(url, callback){
            var s=document.createElement('script');s.type='text/javascript';
            if(s.readyState){s.onreadystatechange=function(){if(s.readyState=='loaded'||s.readyState=='complete'){s.onreadystatechange=null;callback();}};}
            else{s.onload=function(){callback();};}
            s.src=url;document.getElementsByTagName('head')[0].appendChild(s);
          }
          loadScript('https://www.civitatis.com/f/js/vendor/iframeResizer.min.js',function(){
            if(window.iFrameResize){
              iFrameResize({checkOrigin:false,initCallback:function(iframe){
                setTimeout(function(){var e=window.document.createEvent('UIEvents');e.initUIEvent('resize',true,false,window,0);iframe.dispatchEvent(e);});
              }});
            }
          });
        })();
      `;

      const iframe = document.createElement('iframe');
      iframe.className = 'civitatis-iframe';
      iframe.src = 'https://www.civitatis.com/widget-activities/?agencyId=39786&display=compact&cant=20&lang=' + language + '&currency=EUR&zone=499&activities=7347,4060,4054,104686,90383&transfer=0&cmp=Widget_Tenerife_ES&width=100%&hideButton=0&centerContent=1&typeSelection=manual&color=5783dc&typography=Montserrat&removeBackground=1&showShadow=1&roundedButtons=1';
      iframe.width = '100%';
      iframe.frameBorder = '0';
      iframe.setAttribute('data-maxwidth', '100%');
      iframe.style.maxWidth = '100%';
      iframe.style.minHeight = 'calc(100vh - 180px)';

      // Clear container safely (avoid innerHTML for XSS safety)
      while (container.firstChild) {
        container.removeChild(container.firstChild);
      }
      container.appendChild(iframe);
      container.appendChild(script);
    }
  }, [activeTab, language]);

  return (
    <div className="min-h-screen bg-[#FDFBF7] flex flex-col pb-16" data-testid="booking-page">
      {/* Tab buttons */}
      <div className="sticky top-0 z-10 bg-white border-b border-gray-100 px-3 py-2 flex gap-2">
        <button
          onClick={() => setActiveTab('accommodation')}
          className={`flex-1 flex items-center justify-center gap-2 py-3 rounded-xl text-sm font-semibold transition-all ${
            activeTab === 'accommodation'
              ? 'bg-[#38B2AC] text-white shadow-md'
              : 'bg-gray-100 text-gray-600'
          }`}
          data-testid="tab-accommodation"
        >
          <Building2 size={18} />
          {t.accommodation}
        </button>
        <button
          onClick={() => setActiveTab('activities')}
          className={`flex-1 flex items-center justify-center gap-2 py-3 rounded-xl text-sm font-semibold transition-all ${
            activeTab === 'activities'
              ? 'bg-[#38B2AC] text-white shadow-md'
              : 'bg-gray-100 text-gray-600'
          }`}
          data-testid="tab-activities"
        >
          <Ticket size={18} />
          {t.activities}
        </button>
      </div>

      {/* Content */}
      {activeTab === 'accommodation' && (
        <div className="flex-1" data-testid="accommodation-content">
          <iframe
            src="https://reservas.11holidayhomestenerife.com/rentals/holidays-rentals-rentals-p0/"
            className="w-full min-h-[calc(100vh-140px)]"
            title="Alojamientos"
            frameBorder="0"
            allow="payment"
            data-testid="accommodation-iframe"
          />
        </div>
      )}

      {activeTab === 'activities' && (
        <div className="flex-1 px-2 py-4" data-testid="activities-content">
          <div ref={civitatisRef} style={{ textAlign: 'center' }} />
        </div>
      )}
    </div>
  );
};

export default BookingPage;
